import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { HDFSConnection } from '../../connection.models';
import { NotifyService } from '../../../common/services/notify.service';
import { selectConnectionsErrors } from '../../store/connections.selectors';

@Component({
  selector: 'connection-form-hdfs',
  template: `
    <xp-form-validation type="HdfsConnection" [name]="formName">
      <form id="connectionFormHdfs" name="connectionFormHdfs" #form="ngForm" class="form">
        <div class="row">
          <div class="col-md-6">
            <xp-form-group>
              <label for="name">{{ 'connections.form.labels.name' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="name"
                id="name"
                [(ngModel)]="connection.name"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <xp-form-group>
              <label for="username">{{ 'connections.form.labels.username' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="username"
                id="username"
                [(ngModel)]="connection.username"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <div class="form-group" *ngIf="connection.unique_id">
              <label for="unique_id">{{ 'connections.form.labels.unique_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="unique_id"
                id="unique_id"
                [(ngModel)]="connection.unique_id"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </div>
          </div>
          <div class="col-md-6">
            <div class="connection-component-host-port row">
              <div class="col-sm-6">
                <xp-form-group>
                  <label for="name_node_host">{{ 'connections.form.hdfs.labels.name_node_host' | translate }}</label>
                  <xp-input
                    type="text"
                    class="form-control"
                    name="name_node_host"
                    id="name_node_host"
                    [(ngModel)]="connection.name_node_host"
                    placeholder=""
                  ></xp-input>
                </xp-form-group>
              </div>
              <div class="col-sm-6">
                <xp-form-group>
                  <label for="name_node_port"
                    >{{ 'connections.form.hdfs.labels.name_node_port' | translate }}
                    <span class="text-muted">{{ 'generic.labels.optional' | translate }}</span></label
                  >
                  <xp-input
                    type="number"
                    class="form-control"
                    name="name_node_port"
                    id="name_node_port"
                    [(ngModel)]="connection.name_node_port"
                    placeholder=""
                  ></xp-input>
                </xp-form-group>
              </div>
            </div>
            <div class="connection-component-host-port row">
              <div class="col-sm-7">
                <xp-form-group>
                  <label for="httpfs_host">{{ 'connections.form.hdfs.labels.httpfs_host' | translate }}</label>
                  <xp-input
                    type="text"
                    class="form-control"
                    name="httpfs_host"
                    id="httpfs_host"
                    [(ngModel)]="connection.httpfs_host"
                    placeholder=""
                  ></xp-input>
                </xp-form-group>
              </div>
              <div class="col-sm-5">
                <xp-form-group>
                  <label for="httpfs_port">{{ 'connections.form.hdfs.labels.httpfs_port' | translate }}</label>
                  <xp-input
                    type="number"
                    class="form-control"
                    name="httpfs_port"
                    id="httpfs_port"
                    [(ngModel)]="connection.httpfs_port"
                    placeholder=""
                  ></xp-input>
                </xp-form-group>
              </div>
            </div>
          </div>
        </div>
      </form>
    </xp-form-validation>
  `,
})
export class ConnectionFormHdfsComponent extends BaseForm implements BaseFormInterface {
  @Input() connection: Partial<HDFSConnection> = {};
  @Output() formValidationChange = new EventEmitter<boolean>();

  @ViewChild('form') form: NgForm;
  formName = 'connectionFormHdfs';
  successMessageText = 'connection.form.success_message';
  errors$ = this.store.select(selectConnectionsErrors);
  errorTexts = [];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
  ) {
    super();
  }
}
